import {create} from 'zustand';

interface GlobalAlertModalState {
    isOpen: boolean;
    title?: string;
    message: string;
    onConfirm?: () => void;
    buttons?: {label: string; method: 'confirm' | 'cancel'}[];
    open: (
        msg: string,
        onConfirm?: () => void,
        buttons?: {label: string; method: 'confirm' | 'cancel'}[],
        title?: string,
    ) => void;
    close: () => void;
}

interface LoginAlertModalState {
    isOpen: boolean;
    open: () => void;
    close: () => void;
}

export const useGlobalAlertModalStore = create<GlobalAlertModalState>(set => ({
    isOpen: false,
    title: undefined,
    message: '',
    onConfirm: undefined,
    buttons: undefined,
    open: (msg, onConfirm, buttons, title) => set({isOpen: true, title: title, message: msg, onConfirm, buttons}),
    close: () => set({isOpen: false, message: '', onConfirm: undefined}),
}));

export const useLoginAlertModalStore = create<LoginAlertModalState>(set => ({
    isOpen: false,
    open: () => set({isOpen: true}),
    close: () => set({isOpen: false}),
}));

/** 
 * 사용법
 * 기본 얼럿 모달 - 확인 원버튼 타입: useGlobalAlertModalStore.getState().open(message)
 * 기본 얼럿 모달 - 버튼에 메서드 전달 : useGlobalAlertModalStore.getState().open(message, ()=> {[onComfirm에 해당하는 메서드]})
 * 커스텀 얼럿 모달 - 투버튼 타입 : 
  useGlobalAlertModalStore.getState().open(
      message,
      () => {
        //onComfirm에 해당하는 메서드
      },
      [
        {label: [label name], method: ['confirm' | 'cancel']},
        {label: [label name], method: ['confirm' | 'cancel']},
      ],
    );
  
  //예시
  useGlobalAlertModalStore.getState().open(
      '정말 삭제하시겠습니까?',
      () => {
        if (initialData) {
          deleteMutation.mutate(initialData.id);
        }
      },
      [
        {label: '삭제', method: 'confirm'},
        {label: '취소', method: 'cancel'},
      ],
    );
*/
